import NextLink, { LinkProps } from 'next/link'
import React from 'react'
import styled from 'styled-components'
import { tagOutboundURL } from 'utils/tagOutboundURL'

export const Anchor = styled.a<{ underlineOnNormalState?: boolean }>`
  color: var(--neutral-80);
  text-decoration: ${({ underlineOnNormalState = true }) => (underlineOnNormalState ? 'underline' : 'none')};

  &:hover {
    color: black;
    text-decoration: ${({ underlineOnNormalState = true }) => (underlineOnNormalState ? 'underline' : 'none')};
  }
`

interface Props extends LinkProps {
  children: React.ReactNode
  className?: string
  onClick?: (e: React.MouseEvent<Element, MouseEvent>) => void
  underlineOnNormalState?: boolean
}

export const Link = ({ children, className, onClick = () => {}, underlineOnNormalState, ...linkProps }: Props) => {
  let href = linkProps.href
  let externalLinkProps = {}

  if (typeof href === 'string' && href.match(/^https?:\/\//)) {
    // The link is external, tag it with us as the UTM source and open it in a new tab
    href = tagOutboundURL(href)
    externalLinkProps = { target: '_blank', rel: 'noopener' }
  }

  return (
    <NextLink {...linkProps} href={href} passHref legacyBehavior>
      <Anchor className={className} onClick={onClick} underlineOnNormalState={underlineOnNormalState} {...externalLinkProps}>
        {children}
      </Anchor>
    </NextLink>
  )
}
